import React, { useEffect, useRef, useState } from 'react';
import Loader from '../../../../Components/Loader/Loader';
import './EditProfileTab.css';
import { BASEURL, ProfileImg, apiUrl } from '../../../../config';
import { Form, Input, Button, notification } from 'antd';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { UserProfileActionHandler } from '../../../../Redux/Actions/user/SettingsUserProfile';
import { EditProfileActionHandler } from '../../../../Redux/Actions/user/SettingsEditProfile';

const userfill = '/assets/userfill.svg';
const EditProfileTab = () => {
    const dispatch = useDispatch();
    const [api, contextHolder] = notification.useNotification();
    const [loading, setLoading] = useState(false);
    const userProfileData = useSelector(
        (state) => state.SettingsUserProfileData
    );
    const editProfileData = useSelector(
        (state) => state?.SettingsEditProfileData
    );
    const [profileImage, setprofileImage] = useState();

    const [form] = Form.useForm();
    const fileInputRef = useRef(null);

    const readURL = (input) => {
        if (input.files && input.files[0]) {
            const reader = new FileReader();
            reader.onload = function (e) {
                document
                    .getElementById('imagePreview')
                    .querySelector('img').src = e.target.result;
            };
            reader.readAsDataURL(input.files[0]);
        }
    };

    const handleImageClick = () => {
        fileInputRef.current.click();
    };
    const handleFileChange = async (e) => {
        readURL(e.target);

        try {
            setLoading(true);
            const access_token = localStorage.getItem('token');
            const formData = new FormData();
            formData.append('profile_pic', e.target.files[0]);
            formData.append('access_token', access_token);
            const APIurl = BASEURL + 'access-management/users/profilepic';

            const response = await fetch(APIurl, {
                method: 'POST',
                body: formData,
            });

            if (response.status === 200) {
                const responseData = await response.json();
                notification.success({
                    message: 'Success',
                    description: 'Profile image uploaded successfully',
                });
            } else {
                notification.error({
                    message: 'Error',
                    description: response.statusText,
                });
            }
        } catch (error) {
            notification.error({
                message: 'Error',
                description: 'Internal server error occurred',
            });
        } finally {
            setLoading(false);
        }
    };

    const onEditProfileFinish = async (values) => {
        try {
            dispatch(EditProfileActionHandler(values));
        } catch (error) {}
    };

    const fetchData = async () => {
        try {
            dispatch(UserProfileActionHandler());
        } catch (error) {}
    };

    useEffect(() => {
        fetchData();
    }, [editProfileData.edit_profile_data]);

    useEffect(() => {
        if (userProfileData && userProfileData.user_profile_data) {
            const { first_name, last_name, email, profile_picture } =
                userProfileData.user_profile_data;
            setprofileImage(
                userProfileData?.user_profile_data?.profile_picture
            );
            form.setFieldsValue({
                firstName: first_name,
                lastName: last_name,
                email: email,
                profile_picture: profile_picture,
                jobTitle: 'jobTitle',
                companyName: 'companyName',
            });
        }
    }, [userProfileData]);

    return (
        <>
            {contextHolder}
            <div className='profile-container'>
                {loading && <Loader />}
                <Form
                    form={form}
                    initialValues={{
                        firstName: '',
                        jobTitle: '',
                        email: '',
                        lastName: '',
                        companyName: '',
                        profile_picture: '',
                    }}
                    onFinish={onEditProfileFinish}>
                    <label className='profile-image'>Profile Image</label>
                    <div className='ellipse-div'></div>
                    <div id='imagePreview' onClick={handleImageClick}>
                        <img
                            src={profileImage}
                            alt='user-img'
                            className='user-fill-icon'
                        />
                        <input
                            ref={fileInputRef}
                            id='hidden'
                            accept='image/*'
                            className='user_profile_pic'
                            name='avatar'
                            type='file'
                            onChange={handleFileChange}
                        />
                    </div>
                    <div className='edit-profile-main_2'>
                        <div className='edit-profile-tabel'>
                            <div className='edit-profile-rectangle-parent4'>
                                <label className='first-name'>First Name</label>
                                <Form.Item
                                    name='firstName'
                                    rules={[
                                        {
                                            required: true,
                                            message:
                                                'Please input your First Name!',
                                        },
                                    ]}>
                                    <Input
                                        className='group-child5'
                                        placeholder='Enter your First Name'
                                    />
                                </Form.Item>
                            </div>
                            <div className='edit-profile-rectangle-parent4'>
                                <label className='first-name'>Job Title</label>
                                <Form.Item
                                    name='jobTitle'
                                    rules={[
                                        {
                                            required: true,
                                            message:
                                                'Please input your Job Title!',
                                        },
                                    ]}>
                                    <Input
                                        className='group-child5'
                                        placeholder='Enter your Job Title'
                                    />
                                </Form.Item>
                            </div>
                            <div className='edit-profile-rectangle-parent4'>
                                <label className='first-name'>Email</label>
                                <Form.Item
                                    name='email'
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please input your Email!',
                                        },
                                    ]}>
                                    <Input
                                        className='group-child5'
                                        placeholder='Enter your Email'
                                        disabled={true}
                                        style={{
                                            backgroundColor: '#dbdbdb',
                                            color: 'black',
                                        }}
                                    />
                                </Form.Item>
                            </div>
                        </div>
                        <div className='edit-profile-tabel'>
                            <div className='edit-profile-aval-inner'>
                                <div className='edit-profile-rectangle-parent4'>
                                    <label className='first-name'>
                                        Last name
                                    </label>
                                    <Form.Item
                                        name='lastName'
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    'Please input your Last name!',
                                            },
                                        ]}>
                                        <Input
                                            className='group-child5'
                                            placeholder='Enter your Last name'
                                        />
                                    </Form.Item>
                                </div>
                                <div className='edit-profile-rectangle-parent4'>
                                    <label className='first-name'>
                                        Company Name
                                    </label>
                                    <Form.Item
                                        name='companyName'
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    'Please input your Company Name!',
                                            },
                                        ]}>
                                        <Input
                                            className='group-child5'
                                            placeholder='Enter your Company Name'
                                        />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className='edit-profile-tabel-hr'>
                            <div className='hr-border12'></div>
                            <div className='youve-changed-1'>
                                <br />
                                <Form.Item>
                                    <Button
                                        htmlType='submit'
                                        className='add-favourite'>
                                        Update
                                    </Button>
                                    <Link className='cancel' to='/'>
                                        Cancel
                                    </Link>
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        </>
    );
};

export default EditProfileTab;
